/* Task states and accessible controls for the customizer. The existing runtime
   remains responsible for generation, quota, consent, pricing and cart writes. */
(function () {
  'use strict';
  let reviewing = false;
  let ready = false;
  const methodNames = ['upload', 'portrait', 'prompt', 'outfit'];
  const initialMethod = new URLSearchParams(window.location.search).get('method');
  let activeMethod = methodNames.includes(initialMethod) ? initialMethod : '';
  // The heavy editor intentionally waits for interaction. Identify the ad's
  // selected tool immediately, without waking that runtime during landing paint.
  const initialStep = document.getElementById('step-customizer');
  if (activeMethod && initialStep) initialStep.dataset.activeMethod = activeMethod;
  function selectToolButtons() {
    const primary = activeMethod === 'prompt' ? 'portrait' : activeMethod;
    document.querySelectorAll('[data-design-method]').forEach(button => {
      button.setAttribute('aria-pressed', String(button.dataset.designMethod === primary));
    });
  }
  selectToolButtons();
  const studio = key => (window.CUSTOMIZER_I18N.studio || {})[key] || '';
  function setMethod(method) {
    const next = method === 'ai' ? 'portrait' : method;
    if (!methodNames.includes(next)) return;
    activeMethod = next;
    const url = new URL(window.location.href);
    url.searchParams.set('method', activeMethod);
    window.history.replaceState(window.history.state, '', url);
    selectToolButtons();
    if (ready) refresh();
  }
  function start() { if (activeMethod) choose(activeMethod); else openChooser(); }
  function startEmptyDesign() {
    // Re-check state at activation: a stale click must never replace artwork.
    if (!ready || selectedDesignUrl || !$('#step-customizer')?.classList.contains('active')) return;
    start();
  }
  function syncEmptyDesignAction(hasDesign) {
    const action = activeMethod ? studio('start_' + activeMethod) : studio('choose_method');
    all('[data-empty-design-start]').forEach(button => {
      button.hidden = hasDesign;
      button.setAttribute('aria-label', action);
    });
    text('[data-empty-design-label]', action);
  }
  function initEmptyPreviewTap() {
    const stage = $('[data-product-stage]');
    if (!stage) return;
    let origin = null, dragged = true;
    stage.addEventListener('pointerdown', event => {
      origin = { x: event.clientX, y: event.clientY };
      dragged = event.button !== 0;
    }, true); // Observe before the renderer isolates its pointer-down event.
    stage.addEventListener('pointermove', event => {
      if (origin && Math.hypot(event.clientX - origin.x, event.clientY - origin.y) > 8) dragged = true;
    });
    stage.addEventListener('pointercancel', () => { origin = null; dragged = true; });
    stage.addEventListener('click', event => {
      if (!dragged && event.target.closest('[data-inline-360-stage]')) startEmptyDesign();
      origin = null; dragged = true;
    });
  }
  let lastDesign = '';
  let undoState = null;
  let pendingPrompt = null;
  let basisWidth = 0, basisHeight = 0;
  let visibilityObserver;
  let aiReturnFocus = null;
  let chooserReturnFocus = null;
  let editorHome = null;
  let detailsHome = null;
  const visitedEngines = new Set();
  const intersections = new Map();
  const mobileViewport = window.matchMedia('(max-width: 768px)');
  const $ = selector => document.querySelector(selector);
  const all = selector => Array.from(document.querySelectorAll(selector));
  const copy = key => (window.CUSTOMIZER_I18N.journey || {})[key] || '';
  const visible = node => !!node && !!node.getClientRects().length && getComputedStyle(node).visibility !== 'hidden';
  const setHidden = (selector, hidden) => all(selector).forEach(node => { node.hidden = hidden; });
  const text = (selector, value) => all(selector).forEach(node => { node.textContent = value; });
  const focus = node => { if (visible(node)) node.focus({ preventScroll: true }); };
  function scrollTo(node) {
    if (!node) return;
    node.scrollIntoView({ block: 'start', behavior: 'instant' });
    focus(node);
  }
  function announce(message) { text('[data-journey-status]', message); }

  function capture() {
    const image = $('#design-image');
    return selectedDesignUrl && image ? {
      url: selectedDesignUrl, uploaded: selectedDesignUploadedUrl, source: designSource,
      x: designOffsetX, y: designOffsetY, zoom: currentZoom,
      renderW: designRenderW, renderH: designRenderH, basisWidth, basisHeight,
      src: image.getAttribute('src'), width: image.style.width, height: image.style.height
    } : null;
  }
  function remember(cancelPlacement = true) {
    undoState = capture();
    if (cancelPlacement) ++_designGen; // A pending fit must not overwrite an edit.
    $('#design-image')?.classList.remove('is-autoplacing');
    syncUndo();
  }
  function syncUndo() { all('[data-journey-undo]').forEach(button => { button.disabled = !undoState; }); }

  function refresh() {
    const step = $('#step-customizer');
    if (!step) return;
    window.RoboPixelPixelbackReturn?.remember({ brand: selectedBrand, model: selectedModel, method: activeMethod });
    const hasDesign = !!selectedDesignUrl;
    if (lastDesign !== selectedDesignUrl) {
      lastDesign = selectedDesignUrl;
      reviewing = false;
      const tools = $('[data-journey-tools]');
      if (tools) tools.open = false;
    }
    const state = !hasDesign ? 'create' : reviewing ? 'review' : 'edit';
    // 360 inspects artwork: a blank case always returns to the flat view.
    // edit() refreshes the journey itself once 360 has closed.
    if (!hasDesign && window.RoboPixel360Inline?.isActive()) { window.RoboPixel360Inline.edit(); return; }
    const rotating = !!window.RoboPixel360Inline?.isActive();
    step.dataset.journey = state;
    if (activeMethod) step.dataset.activeMethod = activeMethod; else delete step.dataset.activeMethod;
    text('[data-journey-method]', studio(activeMethod || 'choose_method'));
    all('[data-journey-method]').forEach(node => {
      const context = node.closest('.cz-method-context');
      if (!context) return;
      if (activeMethod) context.dataset.tool = activeMethod; else delete context.dataset.tool;
    });
    all('[data-method-start]').forEach(button => { button.hidden = false; button.textContent = activeMethod ? studio('start_' + activeMethod) : studio('choose_method'); });
    const showingDesign = window.RoboPixelProductContext?.refresh({
      hasDesign, designUrl: selectedDesignUrl, brand: selectedBrand, model: selectedModel, state
    }) ?? true;
    syncEmptyDesignAction(hasDesign);
    text('[data-journey-title]', copy(state + '_title'));
    text('[data-journey-description]', copy(state + '_description'));
    text('[data-journey-back-label]', copy(state === 'review' ? 'back_design' : 'back_phone'));
    setHidden('.cz-tool-switcher, [data-workspace-info]', state === 'review');
    text('[data-journey-kicker]', copy(reviewing && hasDesign ? 'review_step' : 'design_step'));
    setHidden('[data-journey-enlarge]', !hasDesign || !showingDesign);
    setHidden('[data-journey-inline-methods]', hasDesign);
    setHidden('[data-journey-tools]', !hasDesign || reviewing || !showingDesign || rotating);
    setHidden('[data-journey-360-edit]', !hasDesign || reviewing || !rotating);
    setHidden('[data-journey-edit-actions]', !hasDesign || reviewing);
    setHidden('[data-journey-edit-return]', !hasDesign || !reviewing);
    setHidden('.customizer-purchase-panel', !hasDesign || !reviewing);
    setHidden('.drag-hint', !hasDesign || reviewing || !showingDesign || rotating);
    setHidden('[data-journey-restore]', !undoState || hasDesign);
    const designStep = $('[data-journey-design-step]');
    const reviewStep = $('[data-journey-review-step]');
    if (designStep && reviewStep) {
      designStep.classList.toggle('is-active', state !== 'review');
      designStep.classList.toggle('is-done', state === 'review');
      designStep.setAttribute('aria-current', state === 'review' ? 'false' : 'step');
      reviewStep.classList.toggle('is-active', state === 'review');
      reviewStep.setAttribute('aria-current', state === 'review' ? 'step' : 'false');
      reviewStep.disabled = !hasDesign;
    }
    text('[data-journey-review-model]', selectedModel);
    // Explicitly distinguish base case price during editing from review total.
    const config = getCustomizerOfferConfig();
    const total = $('[data-customizer-offer-total]');
    const price = $('.mockup-price__now');
    if (price && config.case) price.textContent = state === 'review' && total ? total.textContent : isCustomizerSecondCase() ? config.second_price_html : config.case.price_html;
    text('[data-journey-price-label]', copy(state === 'review' ? 'total' : 'case_price'));
    const bundleDetails = $('[data-journey-bundle-details]');
    if (bundleDetails) {
      bundleDetails.hidden = selectedCustomizerOffer !== 'ecosystem';
      if (bundleDetails.hidden) bundleDetails.open = false;
    }
    const upgrade = $('[data-journey-upgrade]');
    if (upgrade) upgrade.hidden = !!$('#portrait-highres-option')?.hidden;
    selectToolButtons();
    window.OutfitMatch?.refreshHistoryVisibility?.();
    syncUndo();
    syncSticky();
  }

  function syncSticky() {
    const step = $('#step-customizer');
    const bar = $('[data-customizer-mobile-purchase]');
    if (!step || !bar) return;
    const state = step.dataset.journey;
    const button = $('[data-customizer-mobile-next]');
    if (!button) return;
    button.hidden = state === 'create';
    setHidden('[data-customizer-mobile-creation-actions]', state !== 'create');
    const price = $('[data-customizer-mobile-cta-price]');
    const target = state === 'create' ? $('[data-journey-inline-methods]')
      : state === 'edit' ? $('[data-journey-review]') : $('#add-cart-btn');
    // Use actual bounds until the observer delivers its first measurement.
    // Without IntersectionObserver the inline actions remain fully functional.
    const bounds = target?.getBoundingClientRect();
    const inView = intersections.get(target) ?? (!!bounds?.height && bounds.top >= 0 && bounds.bottom <= window.innerHeight);
    // Mobile creation has one persistent dock; desktop keeps its inline fallback.
    const mobileCreate = state === 'create' && mobileViewport.matches;
    const dockFocus = state === 'create' && !mobileCreate && inView && bar.contains(document.activeElement) ? document.activeElement : null;
    bar.dataset.visible = mobileViewport.matches || (target && !inView) ? 'true' : 'false';
    if (dockFocus) focus(target.querySelector(dockFocus.classList.contains('cz-method--outfit') ? '.cz-method--outfit' : dockFocus.classList.contains('cz-method--ai') ? '.cz-method--ai' : '.cz-method--upload'));
    const busy = !!window.__rpCustomizerCartBusy;
    button.disabled = busy;
    button.setAttribute('aria-busy', String(busy));
    const action = busy ? window.CUSTOMIZER_I18N.cart_processing : state === 'create' ? copy('create_title') : state === 'edit' ? copy('review_action')
      : $('#add-cart-btn .rp-atc-action')?.textContent || $('#add-cart-btn')?.textContent || '';
    const summary = busy ? window.CUSTOMIZER_I18N.cart_processing_hint : state === 'create' ? copy('methods_hint') : state === 'edit' ? selectedModel
      : $('#add-cart-btn .rp-atc-summary')?.textContent || selectedModel;
    text('[data-customizer-mobile-cta-label]', action);
    text('[data-customizer-mobile-cta-meta]', summary);
    // Keep the announcement outside the busy button so assistive technology
    // does not defer it until processing finishes. Avoid repeated announcements.
    const status = $('[data-customizer-cart-status]');
    const statusText = busy ? action + ' ' + summary : '';
    if (status && status.textContent !== statusText) status.textContent = statusText;
    if (price) price.hidden = state !== 'review' || !modelConfirmed || !selectedCustomizerOffer;
    all('.customizer-mobile-purchase [data-pair-guidance]').forEach(node => {
      node.hidden = state !== 'review' || selectedCustomizerOffer !== 'pair';
    });
  }
  function initVisibility() {
    if (visibilityObserver || !('IntersectionObserver' in window)) return;
    visibilityObserver = new IntersectionObserver(entries => {
      entries.forEach(entry => intersections.set(entry.target, entry.isIntersecting && entry.intersectionRatio >= 0.95));
      syncSticky();
    }, { threshold: [0, 0.95, 1] });
    ['[data-journey-inline-methods]', '[data-journey-review]', '#add-cart-btn'].forEach(selector => {
      const node = $(selector);
      if (node) visibilityObserver.observe(node);
    });
  }
  function closeToolPanels() {
    closeDetails();
    if (!$('#outfit-match-modal')?.hidden) window.OutfitMatch?.close();
    if ($('#transform-modal')?.classList.contains('active')) { visitedEngines.add('portrait'); closeTransformModal(); }
    if ($('#ai-modal')?.classList.contains('active')) { visitedEngines.add('prompt'); closeAIModal(); }
    closeEditor();
  }
  function openChooser() {
    // Replace the active dialog, never stack a chooser behind a trapped form.
    chooserReturnFocus = document.activeElement?.closest('[role="dialog"]')
      ? $('#step-customizer.active .cz-method-context button') || $('#step-model.active .cz-method-context button')
      : document.activeElement;
    closeToolPanels();
    $('#cz-design-chooser').hidden = false;
    refresh();
  }
  function closeChooser() { $('#cz-design-chooser').hidden = true; }
  function choose(method) {
    method = method === 'ai' ? 'portrait' : method;
    setMethod(method);
    if (!ready) return; // Tool intent is safe before the lazy editor has initialized.
    if (!$('#step-customizer')?.classList.contains('active')) { closeChooser(); return; }
    // Switching keeps the current mockup until another result is applied.
    closeToolPanels();
    if (method === 'outfit') { closeChooser(); window.OutfitMatch?.open(); return; }
    aiReturnFocus = !$('#cz-design-chooser').hidden ? chooserReturnFocus : document.activeElement;
    closeChooser();
    if (method === 'upload') triggerUpload();
    else {
      const engine = method === 'prompt' ? 'prompt' : 'portrait';
      if (visitedEngines.has(engine)) {
        // Resume the existing draft/result. The generation handler still owns
        // consent, security and quota validation; reopening must not reset input.
        selectPhotoConsentMode('ai');
        $(engine === 'portrait' ? '#transform-modal' : '#ai-modal').classList.add('active');
        document.body.style.overflow = 'hidden';
        if (engine === 'portrait' && typeof refreshTransformStartState === 'function') refreshTransformStartState();
        return;
      }
      if (engine === 'portrait') showTransformModal();
      else showAIModal();
    }
  }
  function switchAI(engine) {
    if (methodNames.includes(engine)) setMethod(engine);
    if (engine !== 'portrait' && engine !== 'prompt') return;
    const target = $(engine === 'portrait' ? '#transform-modal' : '#ai-modal');
    const source = $(engine === 'portrait' ? '#ai-modal' : '#transform-modal');
    if (!target || !visible(source) || visible(target)) return;
    if (source.id === 'transform-modal' && typeof cancelPortraitPending === 'function') cancelPortraitPending();
    // Suspend the current panel without resetting its photo, selected style,
    // result, consent or an in-flight generation. Service gates still run on
    // first entry, and generation handlers continue to validate every request.
    visitedEngines.add(engine === 'portrait' ? 'prompt' : 'portrait');
    source.classList.remove('active');
    releaseOverlayFocusTrap();
    if (visitedEngines.has(engine)) {
      target.classList.add('active');
      document.body.style.overflow = 'hidden';
    } else {
      visitedEngines.add(engine);
      if (engine === 'prompt') showAIModal(false);
      else showTransformModal();
    }
    requestAnimationFrame(() => focus(target.querySelector('[aria-selected="true"]')));
  }
  function review() {
    if (!selectedDesignUrl) { openChooser(); return; }
    closeToolPanels();
    recordSize();
    window.RoboPixel360Inline?.edit();
    window.RoboPixelProductContext?.showDesign();
    if (!reviewing) {
      // Keep the exact design entry (and its URL) underneath Review. Back is
      // navigation, never an artwork reset or another automatic fit.
      history.replaceState({ ...history.state, robopixelStep: 'design' }, '', window.location.href);
      history.pushState({ ...history.state, robopixelStep: 'review', robopixelPreviousStep: 'design' }, '', window.location.href);
    }
    reviewing = true;
    announce('');
    clearCustomizerOfferPrompt();
    refresh();
    syncSize();
    dismissGestureCoach();
    scrollTo($('[data-journey-title]'));
  }
  function edit() {
    if (reviewing && history.state?.robopixelStep === 'review' && history.state?.robopixelPreviousStep === 'design') {
      history.back();
      return;
    }
    restoreStep('design');
    history.replaceState({ ...history.state, robopixelStep: 'design' }, '', window.location.href);
  }
  function back() {
    if (reviewing) edit();
    else resetToModel();
  }
  function restoreStep(target) {
    closeToolPanels();
    recordSize();
    if (target !== 'design') window.RoboPixel360Inline?.edit();
    window.RoboPixelProductContext?.showDesign();
    reviewing = target === 'review' && !!selectedDesignUrl;
    announce('');
    refresh();
    syncSize();
    if (target !== 'model') scrollTo($('[data-journey-title]'));
  }
  function openDetails() {
    const details = $('[data-product-details]');
    const dialog = $('#cz-case-details-dialog');
    if (!details || !dialog || detailsHome) return;
    detailsHome = document.createComment('case-details-home');
    details.before(detailsHome);
    $('[data-workspace-details-content]').append(details);
    details.open = true;
    dialog.hidden = false;
  }
  function closeDetails() {
    if (!detailsHome) return;
    const details = $('[data-product-details]');
    details.open = false;
    detailsHome.replaceWith(details);
    detailsHome = null;
    $('#cz-case-details-dialog').hidden = true;
  }
  function openEditor() {
    if (!selectedDesignUrl || editorHome) return;
    window.RoboPixel360Inline?.edit();
    window.RoboPixelProductContext?.showDesign();
    dismissGestureCoach();
    remember(false); // Opening controls is not a manual crop adjustment.
    recordSize();
    const stage = $('[data-product-stage]');
    editorHome = document.createComment('placement-editor-home');
    stage.before(editorHome);
    $('#cz-placement-editor').hidden = false;
    $('[data-placement-stage]').append(stage);
    syncSize();
    placement();
  }
  function closeEditor() {
    if (!editorHome) return;
    endZoom();
    const options = $('.cz-placement-options');
    if (options) options.open = false;
    recordSize();
    editorHome.replaceWith($('[data-product-stage]'));
    editorHome = null;
    $('#cz-placement-editor').hidden = true;
    syncSize();
  }
  function phoneSelected() {
    if (!selectedDesignUrl && activeMethod === 'outfit') choose('outfit');
  }
  function purchase() {
    if (!selectedDesignUrl) { openChooser(); return; }
    if (!reviewing) { review(); return; }
    if (!modelConfirmed) { openModelSheet(true); return; }
    const offers = $('[data-customizer-offers]');
    if (offers && !selectedCustomizerOffer) {
      // Navigating to a normal choice is not a validation error.
      clearCustomizerOfferPrompt();
      const first = offers.querySelector('input:not(:disabled)');
      scrollTo(first || offers);
      return;
    }
    addToCart();
  }
  function zoom(delta) {
    if (!selectedDesignUrl) return;
    endZoom();
    remember();
    currentZoom = Math.max(ZOOM_MIN, Math.min(ZOOM_MAX, currentZoom + delta));
    dismissGestureCoach();
    updateDesignTransform();
  }
  let zoomEditing = false;
  function setZoom(value) {
    const next = Number(value);
    if (!selectedDesignUrl || !Number.isFinite(next)) return;
    // One undo point for a whole slider gesture, including keyboard changes.
    if (!zoomEditing) { remember(); zoomEditing = true; }
    currentZoom = Math.max(ZOOM_MIN, Math.min(ZOOM_MAX, next));
    dismissGestureCoach();
    updateDesignTransform();
  }
  function endZoom() { zoomEditing = false; }
  function resetLayout() {
    if (!selectedDesignUrl) return;
    endZoom();
    remember();
    // Reuse the initial gap-free fit and its existing asynchronous edit guard.
    autoFitDesign();
  }
  function center() {
    if (!selectedDesignUrl) return;
    endZoom();
    remember();
    designOffsetX = 0;
    designOffsetY = 0;
    dismissGestureCoach();
    updateDesignTransform();
  }
  function move(x, y) {
    if (!selectedDesignUrl) return;
    endZoom();
    remember();
    designOffsetX += x;
    designOffsetY += y;
    dismissGestureCoach();
    updateDesignTransform();
  }
  function remove() {
    window.RoboPixel360Inline?.edit();
    remember();
    resetDesignState();
    announce(copy('removed'));
    refresh();
    scrollTo($('[data-journey-title]'));
  }
  function undo() {
    if (!undoState) return;
    const restoringRemoved = !selectedDesignUrl;
    const state = undoState;
    undoState = null;
    ++_designGen;
    selectedDesignUrl = state.url;
    selectedDesignUploadedUrl = state.uploaded;
    designSource = state.source;
    designOffsetX = state.x; designOffsetY = state.y; currentZoom = state.zoom;
    designRenderW = state.renderW; designRenderH = state.renderH;
    basisWidth = state.basisWidth; basisHeight = state.basisHeight;
    const image = $('#design-image');
    image.onload = null;
    image.src = state.src;
    image.style.width = state.width; image.style.height = state.height;
    image.style.display = 'block';
    updateDesignTransform();
    refreshUploadTrustLine();
    announce(copy('undone'));
    refresh();
    placement();
    syncSize();
    if (restoringRemoved) scrollTo($('[data-journey-title]'));
  }
  function recordSize() {
    const zone = $('.design-clip-zone');
    if (zone?.offsetWidth && zone.offsetHeight) { basisWidth = zone.offsetWidth; basisHeight = zone.offsetHeight; }
  }
  function syncSize() {
    const zone = $('.design-clip-zone');
    if (!selectedDesignUrl || !zone?.offsetWidth || !zone.offsetHeight) return;
    if (!basisWidth || !basisHeight) { recordSize(); return; }
    const rx = zone.offsetWidth / basisWidth, ry = zone.offsetHeight / basisHeight;
    if (Math.abs(rx - 1) < .001 && Math.abs(ry - 1) < .001) return;
    // Pending subject positioning remeasures the window after detection.
    // Only a user edit/new image invalidates it, not responsive layout changes.
    designRenderW *= rx; designRenderH *= ry;
    designOffsetX *= rx; designOffsetY *= ry;
    const image = $('#design-image');
    image.classList.remove('is-autoplacing');
    image.style.width = designRenderW + 'px'; image.style.height = designRenderH + 'px';
    recordSize();
    updateDesignTransform();
  }
  function placement() {
    text('[data-journey-zoom]', Math.round(currentZoom * 100) + '%');
    all('[data-placement-zoom]').forEach(slider => {
      slider.min = ZOOM_MIN;
      slider.max = ZOOM_MAX;
      slider.value = currentZoom;
      slider.setAttribute('aria-valuetext', Math.round(currentZoom * 100) + '%');
    });
  }
  function showPromptResult(url, uploadedUrl) {
    pendingPrompt = { url, uploadedUrl };
    const preview = $('[data-journey-prompt-image]');
    preview.src = rpDisplayUrl(url);
    rpShieldPreviewSurface(preview, () => rpHasCleanTwin(url));
    setHidden('[data-journey-prompt-result]', false);
    setHidden('[data-journey-prompt-form]', true);
    focus($('[data-journey-prompt-use]'));
  }
  function usePromptResult() {
    if (!pendingPrompt) return;
    remember();
    applyPromptImageToCanvas(pendingPrompt.url, pendingPrompt.uploadedUrl);
    pendingPrompt = null;
    setHidden('[data-journey-prompt-result]', true);
    setHidden('[data-journey-prompt-form]', false);
    closeAIModal();
    edit();
  }
  function retryPrompt() {
    setHidden('[data-journey-prompt-result]', true);
    setHidden('[data-journey-prompt-form]', false);
    focus($('#ai-prompt'));
  }

  // One modal pattern, including nested photo consent. Existing action handlers
  // still own open/close and service behavior; this adds focus and background isolation.
  function initDialogs() {
    const closers = {
      'outfit-match-modal': () => window.OutfitMatch?.close(),
      'cz-placement-editor': closeEditor,
      'cz-case-details-dialog': closeDetails,
      'cz-design-chooser': closeChooser, 'ai-modal': closeAIModal,
      'model-sheet': closeModelSheet, 'transform-modal': closeTransformModal, 'crop-modal': closeCropModal,
      'enlarge-modal': closeEnlargeModal,
      'create-chooser-modal': closeAIChooser
    };
    const dialogs = Object.keys(closers).map(id => document.getElementById(id)).filter(Boolean);
    let stack = [], inertNodes = [], lastTrigger = null;
    let originalOverflow = '';
    const openers = new Map();
    const focusable = node => Array.from(node.querySelectorAll('button:not(:disabled),a[href],input:not(:disabled),textarea:not(:disabled),select:not(:disabled),summary,[tabindex]:not([tabindex="-1"])')).filter(visible);
    document.addEventListener('click', event => {
      const target = event.target.closest('button,a,label,summary,[role="button"]');
      if (target) lastTrigger = target;
    }, true);
    function restoreBackground() { inertNodes.forEach(([node, value]) => { node.inert = value; }); inertNodes = []; }
    function isolate(node) {
      let branch = node;
      while (branch && branch !== document.body) {
        const parent = branch.parentElement;
        if (!parent) break;
        Array.from(parent.children).forEach(sibling => {
          if (sibling === branch || /^(SCRIPT|STYLE|LINK)$/.test(sibling.tagName)) return;
          inertNodes.push([sibling, sibling.inert]); sibling.inert = true;
        });
        branch = parent;
      }
    }
    function sync() {
      const shown = dialogs.filter(visible);
      const added = shown.filter(node => !stack.includes(node));
      const priorTop = stack[stack.length - 1];
      if (!stack.length && shown.length) originalOverflow = document.body.style.overflow;
      added.forEach(node => {
        const aiOpener = (node.id === 'ai-modal' || node.id === 'transform-modal') && aiReturnFocus;
        openers.set(node, node.id === 'cz-design-chooser' ? chooserReturnFocus : aiOpener || (lastTrigger && !node.contains(lastTrigger) ? lastTrigger : document.activeElement));
        node.setAttribute('role', 'dialog'); node.setAttribute('aria-modal', 'true'); node.tabIndex = -1;
      });
      stack = stack.filter(node => shown.includes(node)).concat(added);
      const top = stack[stack.length - 1];
      restoreBackground();
      document.body.classList.toggle('cz-dialog-open', !!top);
      if (top) {
        if (top !== priorTop || !top.contains(document.activeElement)) focus(top.querySelector('[data-dialog-heading]') || focusable(top)[0] || top);
        isolate(top);
        document.body.style.overflow = 'hidden';
      } else if (priorTop) {
        // Existing close handlers clear overflow; do not restore their temporary lock.
        document.body.style.overflow = originalOverflow === 'hidden' ? '' : originalOverflow;
        const opener = openers.get(priorTop);
        focus(visible(opener) ? opener : $('[data-journey-title]'));
      }
      if (priorTop && priorTop !== top && !shown.includes(priorTop)) openers.delete(priorTop);
    }
    const observer = new MutationObserver(sync);
    dialogs.forEach(node => {
      observer.observe(node, { attributes: true, attributeFilter: ['class', 'hidden', 'style'] });
    });
    document.addEventListener('keydown', event => {
      const top = stack[stack.length - 1];
      if (!top || (event.key !== 'Tab' && event.key !== 'Escape')) return;
      if (event.key === 'Escape') {
        event.preventDefault(); event.stopImmediatePropagation(); closers[top.id](); return;
      }
      const targets = focusable(top);
      const first = targets[0] || top, last = targets[targets.length - 1] || top;
      if (!top.contains(document.activeElement) || (event.shiftKey && document.activeElement === first) || (!event.shiftKey && document.activeElement === last)) {
        event.preventDefault(); focus(event.shiftKey ? last : first);
      }
      event.stopImmediatePropagation();
    }, true);
    $('#cz-design-chooser')?.addEventListener('click', event => {
      if (event.target.id === 'cz-design-chooser') closeChooser();
    });
    sync();
  }

  window.RoboPixelJourney = { method: () => activeMethod, setMethod, start, startEmptyDesign, refresh, initVisibility, openChooser, closeChooser, choose, switchAI, review, edit, purchase,
    back, restoreStep, openDetails, closeDetails,
    openEditor, closeEditor, phoneSelected,
    zoom, setZoom, endZoom, resetLayout, center, move, remove, undo, remember, recordSize, placement, showPromptResult, usePromptResult, retryPrompt, announce };
  function init() {
    ready = true;
    // Native scroll restoration runs after popstate and can otherwise pull the
    // shopper away from the restored step's Back button. Restore the browser's
    // default when leaving this document (including bfcache navigation).
    const previousScrollRestoration = history.scrollRestoration;
    history.scrollRestoration = 'manual';
    window.addEventListener('pagehide', () => { history.scrollRestoration = previousScrollRestoration; });
    window.addEventListener('pageshow', () => { history.scrollRestoration = 'manual'; });
    initDialogs(); initVisibility(); initEmptyPreviewTap(); refresh();
    const pendingPhone = window.RoboPixelPendingModel;
    if (pendingPhone?.isConnected && pendingPhone.dataset.available !== 'false') {
      window.RoboPixelPendingModel = null;
      pendingPhone.removeAttribute('aria-busy');
      const brand = pendingPhone.closest('[data-brand]')?.dataset.brand;
      if (brand) selectBrand(brand);
      selectModel(pendingPhone);
    }
    all('[data-ai-engine]').forEach(tab => tab.addEventListener('keydown', event => {
      if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
      event.preventDefault();
      const engine = event.key === 'Home' ? 'portrait' : event.key === 'End' ? 'prompt'
        : tab.dataset.aiEngine === 'portrait' ? 'prompt' : 'portrait';
      switchAI(engine);
    }));
    $('#design-image')?.addEventListener('load', placement);
    window.addEventListener('resize', syncSize);
    mobileViewport.addEventListener('change', syncSticky);
    if ('ResizeObserver' in window) {
      const zone = $('.design-clip-zone');
      if (zone) new ResizeObserver(syncSize).observe(zone);
      const bar = $('[data-customizer-mobile-purchase]');
      if (bar) new ResizeObserver(() => {
        // Include wrapped translations and enlarged text in the page clearance.
        if (bar.offsetHeight) document.documentElement.style.setProperty('--cz-create-dock-height', bar.offsetHeight + 'px');
      }).observe(bar);
    }
  }
  if (typeof window.RoboPixelCustomizerReady === 'function') window.RoboPixelCustomizerReady(init);
  else document.addEventListener('robopixel:customizer-ready', init, { once: true });
})();
